export type CountrySelection = string | string[] | null | undefined;

const normalizeCountry = (value?: string | null) =>
  (value || "")
    .toLowerCase()
    .replace(/\./g, "")
    .replace(/\s+/g, " ")
    .trim();

const canonicalCountry = (value?: string | null) => {
  const normalized = normalizeCountry(value);
  if (!normalized) return "";
  if (normalized === "uae" || normalized === "united arab emirates") {
    return "united arab emirates";
  }
  if (normalized === "in" || normalized === "india") return "india";
  if (normalized === "global" || normalized === "all") return "global";
  return normalized;
};

const splitSelection = (selection: CountrySelection): string[] => {
  if (Array.isArray(selection)) {
    return selection.map((item) => canonicalCountry(String(item))).filter(Boolean);
  }

  if (typeof selection === "string") {
    return selection
      .split(/[,|;/]+/)
      .map((item) => canonicalCountry(item))
      .filter(Boolean);
  }

  return [];
};

const resolveSiteCountry = (siteRegion?: string | null) => {
  const normalized = normalizeCountry(siteRegion);
  if (normalized === "in" || normalized === "india") return "india";
  if (normalized === "ae" || normalized === "uae" || normalized === "united arab emirates") {
    return "united arab emirates";
  }
  return "global";
};

export const isMatchingCountry = (
  selection: CountrySelection,
  siteRegion?: string | null
) => {
  const selectedCountries = splitSelection(selection);
  if (selectedCountries.length === 0) return true;

  const siteCountry = resolveSiteCountry(siteRegion);
  return selectedCountries.includes(siteCountry);
};

export const filterByCountrySelection = <T,>(
  items: T[],
  getSelection: (item: T) => CountrySelection,
  siteRegion?: string | null
) => {
  const taggedItems = items.filter((item) => splitSelection(getSelection(item)).length > 0);
  const matchingTaggedItems = taggedItems.filter((item) =>
    isMatchingCountry(getSelection(item), siteRegion)
  );
  const untaggedItems = items.filter((item) => splitSelection(getSelection(item)).length === 0);

  if (matchingTaggedItems.length > 0) {
    return [...matchingTaggedItems, ...untaggedItems];
  }

  if (taggedItems.length > 0) {
    return untaggedItems;
  }

  return items;
};
